// Over the map, bottom: I'm free on the left (the profile's slot), Show my location on the right. Add event waits for
// its redesign (docs/ARCHITECTURE.md §3 slice 4). They ride on the phone's list bar (--nearby-h) and fade while a
// filter dropdown is open.
import { T } from "../shared/config";
import { Icon } from "../shared/icons";
import { moveMap, setFindingYou, viewStore } from "../state/view";
import { FreePill } from "../features/profile/slots";
import { locate } from "./location";
import styles from "./MapButtons.module.css";

export function MapButtons() {
  const onLocate = () => {
    const loc = viewStore.getState().userLocation;
    if (loc) moveMap(loc, 15);
    // No fix yet: ask again and say "Finding you…" rather than jumping somewhere else.
    else { setFindingYou(true); locate((l) => moveMap(l, 15)); }
  };
  return (
    <div id="map-ui" className={styles.ui}>
      <div className={styles.bottom}>
        <div className={styles.left} data-map-control=""><FreePill /></div>
        <div className={styles.buttons}>
          <button type="button" id="locate" className={styles.circle} aria-label={T("locate")} title={T("locate")} data-map-control="" onClick={onLocate}>
            <Icon name="current-location" />
          </button>
        </div>
      </div>
    </div>
  );
}
